import { gql } from '@apollo/client'

export const CUSTOMER_SHIPPING_RATE_ROLES = ['super_admin', 'admin']

export const BASE_PATH = '/customer_shipping_rates'
export const FULL_TRUCK_LOAD_PATH = `${BASE_PATH}/full_truck_load`

export const basketSizeDetailPath = provinceId => `${BASE_PATH}/basket_size/${provinceId}`

const PERMISSION_FIELDS = `
  customerShippingRatePermissions {
    canEditBasketSizeRates
    canImportBasketSizeRates
    canEditFullTruckLoadRates
  }
`

export const PROVINCE_BASKET_SIZE_RATES_FIELDS = gql`
  fragment ProvinceBasketSizeRatesFields on AdminProvinceBasketSizeRates {
    province { id name }
    tiers { id maximum percentage updatedAt }
    hasCatchAll
    fullTruckLoadPercentage
    updatedAt
    canEdit
  }
`

export const BASKET_SIZE_RATES_QUERY = gql`
  query CustomerBasketSizeRates {
    basketSizeRates {
      ...ProvinceBasketSizeRatesFields
    }
    provinces { id name }
    ${PERMISSION_FIELDS}
  }
  ${PROVINCE_BASKET_SIZE_RATES_FIELDS}
`

export const PROVINCE_BASKET_SIZE_RATES_QUERY = gql`
  query CustomerProvinceBasketSizeRates($provinceId: ID!) {
    basketSizeRates(provinceId: $provinceId) {
      ...ProvinceBasketSizeRatesFields
    }
  }
  ${PROVINCE_BASKET_SIZE_RATES_FIELDS}
`

export const FULL_TRUCK_LOAD_RATES_QUERY = gql`
  query CustomerFullTruckLoadRates {
    fullTruckLoadRates {
      id
      percentage
      updatedAt
      province { id name }
    }
    provinces { id name }
    ${PERMISSION_FIELDS}
  }
`

export const REPLACE_BASKET_SIZE_RATES_MUTATION = gql`
  mutation ReplaceBasketSizeRates($provinceId: ID!, $tiers: [AdminBasketSizeTierInput!]!) {
    replaceBasketSizeRates(provinceId: $provinceId, tiers: $tiers) {
      rates {
        ...ProvinceBasketSizeRatesFields
      }
      errors { key message }
    }
  }
  ${PROVINCE_BASKET_SIZE_RATES_FIELDS}
`

export const IMPORT_BASKET_SIZE_RATES_MUTATION = gql`
  mutation ImportBasketSizeRates($objectKey: String!, $filename: String) {
    importBasketSizeRates(objectKey: $objectKey, filename: $filename) {
      result {
        enqueued
        objectKey
        errors { key message }
      }
    }
  }
`

export const CREATE_DIRECT_UPLOAD_URL_MUTATION = gql`
  mutation CustomerShippingRatesDirectUploadUrl($filename: String!) {
    createDirectUploadUrl(filename: $filename) {
      contentType
      directUploadUrl
      s3ObjectKey
    }
  }
`

export const UPSERT_FULL_TRUCK_LOAD_RATE_MUTATION = gql`
  mutation UpsertFullTruckLoadRate($provinceId: ID!, $percentage: Float!) {
    upsertFullTruckLoadRate(provinceId: $provinceId, percentage: $percentage) {
      fullTruckLoadRate {
        id
        percentage
        updatedAt
        province { id name }
      }
      errors { key message }
    }
  }
`

export const DELETE_FULL_TRUCK_LOAD_RATE_MUTATION = gql`
  mutation DeleteFullTruckLoadRate($provinceId: ID!) {
    deleteFullTruckLoadRate(provinceId: $provinceId) {
      deletedProvinceId
    }
  }
`

export const formatMutationErrors = (errors = []) =>
  errors.map(({ key, message }) => (key ? `${key} ${message}` : message)).join(', ')

const trimNumber = value => Number(value.toFixed(4)).toString()

export const multiplierAsPercent = (value) => {
  if (value === null || value === undefined || value === '') return null

  return `${trimNumber(Number(value) * 100)}%`
}

export const formatPercent = (value) => {
  if (value === null || value === undefined) return '-'

  return `${trimNumber(Number(value))}%`
}

export const formatBaht = value => Number(value).toLocaleString('th-TH', { maximumFractionDigits: 2 })
